// Core component styles
const coreStyles = {
    chartTextStyle: {
    },

    container: {
    },

    legendContainerStyle: {
        bottom: 10,
        left: 'center',
        lineHeight: 14,
    },

    legendTextStyle: {
    },

    titleTextStyle: {
    },

    tooltipContainerStyle: {
        backgroundColor: '#fff',
        borderColor: '#ccc',
        borderRadius: 6,
        borderWidth: 1,
        boxShadow: '0px 1px 4px 1px rgba(0, 0, 0, 0.25)',
    },

    tooltipTextStyle: {
        lineHeight: 14,
    },

    xAxisTextStyle: {
    },

    xAxisLabelTextStyle: {
    },

    yAxisTextStyle: {
    },
};

/**
 * Helper method to get styles for the Line Chart
 * @param {Object} contextStyles - custom styles for the line chart
 */
const getStyles = (contextStyles) => {
    return {
        chartTextStyle: {
            ...coreStyles.chartTextStyle,
            ...contextStyles.chartTextStyle,
        },

        container: {
            ...coreStyles.container,
            ...contextStyles.container,
        },

        legendContainerStyle: {
            ...coreStyles.legendContainerStyle,
            ...contextStyles.legendContainerStyle,
        },

        legendTextStyle: {
            ...coreStyles.legendTextStyle,
            ...contextStyles.legendTextStyle,
        },

        titleTextStyle: {
            ...coreStyles.titleTextStyle,
            ...contextStyles.titleTextStyle,
        },

        tooltipContainerStyle: {
            ...coreStyles.tooltipContainerStyle,
            ...contextStyles.tooltipContainerStyle,
        },

        tooltipTextStyle: {
            ...coreStyles.tooltipTextStyle,
            ...contextStyles.tooltipTextStyle,
        },

        xAxisTextStyle: {
            ...coreStyles.xAxisTextStyle,
            ...contextStyles.xAxisTextStyle,
        },

        xAxisLabelTextStyle: {
            ...coreStyles.xAxisLabelTextStyle,
            ...contextStyles.xAxisLabelTextStyle,
        },

        yAxisTextStyle: {
            ...coreStyles.yAxisTextStyle,
            ...contextStyles.yAxisTextStyle,
        },
    };
};

export default getStyles;
